export default __webpack_public_path__ + "static/media/mapimg.bc927ee4.jpg";